import { render, staticRenderFns } from "./materialSelect.vue?vue&type=template&id=538a19e0&scoped=true&"
import script from "./materialSelect.vue?vue&type=script&lang=js&"
export * from "./materialSelect.vue?vue&type=script&lang=js&"
import style0 from "./materialSelect.vue?vue&type=style&index=0&id=538a19e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538a19e0",
  null
  
)

export default component.exports